'use strict';
require('../../modules/es.date.to-primitive');
require('../../modules/es.symbol.to-primitive');
var WrappedWellKnownSymbolModule = require('../../internals/well-known-symbol-wrapped');

module.exports = WrappedWellKnownSymbolModule.f('toPrimitive');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/symbol/to-primitive.js
// module id = 9bWI
// module chunks = 15